export class FeatureStatusService {
  public static status(
    featureIds: string[],
    environment: { [key: string]: string | undefined } = process.env,
  ): { [featureId: string]: boolean } {
    const result: { [featureId: string]: boolean } = {};
    featureIds.forEach((featureId) => {
      const envFeatureSetting = environment[`STATUS_${featureId}`];
      result[featureId] = envFeatureSetting
        ? envFeatureSetting === 'true'
        : true;
    });
    return result;
  }
}
